(function () {
  var root = document.querySelector('[data-mc-cart]');
  if (!root) return;

  var config = window.QuillmoreCartConfig || {};
  var strings = config.strings || {};
  var drawer = root.querySelector('.mc-cart__drawer');
  var body = root.querySelector('[data-mc-cart-body]');
  var footer = root.querySelector('[data-mc-cart-footer]');
  var subtotal = root.querySelector('[data-mc-cart-subtotal]');
  var compareTotal = root.querySelector('[data-mc-cart-compare]');
  var total = root.querySelector('[data-mc-cart-total]');
  var checkoutTotal = root.querySelector('[data-mc-cart-checkout-total]');
  var savingRow = root.querySelector('[data-mc-cart-saving-row]');
  var saving = root.querySelector('[data-mc-cart-saving]');
  var checkout = root.querySelector('[data-mc-cart-checkout]');
  var lastFocus = null;
  var previousOverflow = '';
  var busy = false;

  var rootUrl = String(config.rootUrl || '/');
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';
  var endpoints = {
    cart: rootUrl + 'cart.js',
    add: rootUrl + 'cart/add.js',
    change: rootUrl + 'cart/change.js',
    checkout: rootUrl + 'checkout'
  };

  if (checkout) checkout.href = endpoints.checkout;

  function esc(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function tr(key, fallback) {
    return strings[key] || fallback;
  }

  function money(cents, currency) {
    var activeCurrency = currency || config.currency || 'USD';
    try {
      return new Intl.NumberFormat(config.locale || 'en', {
        style: 'currency',
        currency: activeCurrency
      }).format(Number(cents || 0) / 100);
    } catch (_) {
      return (Number(cents || 0) / 100).toFixed(2) + ' ' + activeCurrency;
    }
  }

  function setBusy(state) {
    busy = !!state;
    root.classList.toggle('is-busy', busy);
    body.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function open() {
    if (root.hidden) {
      lastFocus = document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
    }
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () { drawer.focus(); });
  }

  function close() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = previousOverflow;
    setBusy(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function updateBadges(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
      element.textContent = cart.item_count || 0;
    });
    root.querySelectorAll('[data-mc-cart-count]').forEach(function (element) {
      element.textContent = cart.item_count || 0;
    });
  }

  function productImage(item) {
    if (!item.image) return '<span class="mc-cart__item-image" aria-hidden="true"></span>';
    var separator = item.image.indexOf('?') > -1 ? '&' : '?';
    var imageUrl = item.image + separator + 'width=172';
    return '<a class="mc-cart__item-image" href="' + esc(item.url) + '" tabindex="-1">' +
      '<img src="' + esc(imageUrl) + '" alt="' + esc(item.product_title) + '" width="86" height="86">' +
      '</a>';
  }

  function offerMarkup(item) {
    var properties = item.properties || {};
    var offer = properties.Offer || properties.offer || '';
    if (!offer) return '';
    return '<div class="mc-cart__offer">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><path d="M7.5 7.5h.01"/></svg>' +
      '<span>' + esc(offer) + '</span></div>';
  }

  function variantMarkup(item) {
    var properties = item.properties || {};
    var offer = properties.Offer || properties.offer || '';
    if (offer || !item.variant_title || item.variant_title === 'Default Title') return '';
    return '<div class="mc-cart__variant">' + esc(item.variant_title) + '</div>';
  }

  function subscriptionMarkup(item) {
    var allocation = item.selling_plan_allocation;
    if (!allocation || !allocation.selling_plan) return '';
    return '<div class="mc-cart__subscription">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 7v5h-5"/><path d="M4 17v-5h5"/><path d="M6.1 9a7 7 0 0 1 11.6-2L20 9M4 15l2.3 2a7 7 0 0 0 11.6-2"/></svg>' +
      '<span>' + esc(allocation.selling_plan.name) + '</span></div>';
  }

  function discountsMarkup(item) {
    var allocations = item.line_level_discount_allocations || [];
    if (!allocations.length) return '';
    return allocations.map(function (allocation) {
      var title = allocation.discount_application && allocation.discount_application.title;
      return title ? '<div class="mc-cart__discount">' + esc(title) + '</div>' : '';
    }).join('');
  }

  function pricingMarkup(item, currency) {
    var compareAtUnit = Number((config.variantCompareAt || {})[String(item.variant_id)] || 0);
    var compareAtLine = compareAtUnit * Number(item.quantity || 1);
    var original = Math.max(Number(item.original_line_price || 0), compareAtLine, Number(item.final_line_price || 0));
    var finalPrice = Number(item.final_line_price || 0);
    var saved = Math.max(0, original - finalPrice);
    return '<div class="mc-cart__item-pricing">' +
      '<strong class="mc-cart__price">' + money(finalPrice, currency) + '</strong>' +
      (saved > 0 ? '<s class="mc-cart__compare">' + money(original, currency) + '</s>' : '') +
      (saved > 0 ? '<span class="mc-cart__line-saving">' + esc(tr('save', 'Save')) + ' ' + money(saved, currency) + '</span>' : '') +
      '</div>';
  }

  function itemMarkup(item, index, currency) {
    return '<article class="mc-cart__item" data-mc-line="' + index + '">' +
      productImage(item) +
      '<div class="mc-cart__item-copy">' +
        '<a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
        offerMarkup(item) +
        variantMarkup(item) +
        subscriptionMarkup(item) +
        discountsMarkup(item) +
        '<div class="mc-cart__item-actions">' +
          '<div class="mc-cart__qty" aria-label="' + esc(tr('quantity', 'Quantity')) + '">' +
            '<button type="button" data-mc-change="' + index + '" data-qty="' + (item.quantity - 1) + '" aria-label="' + esc(tr('decreaseQuantity', 'Decrease quantity')) + '">−</button>' +
            '<span aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" data-mc-change="' + index + '" data-qty="' + (item.quantity + 1) + '" aria-label="' + esc(tr('increaseQuantity', 'Increase quantity')) + '">+</button>' +
          '</div>' +
          '<button class="mc-cart__remove" type="button" data-mc-change="' + index + '" data-qty="0">' + esc(tr('remove', 'Remove')) + '</button>' +
        '</div>' +
      '</div>' +
      pricingMarkup(item, currency) +
      '</article>';
  }

  function emptyMarkup() {
    return '<div class="mc-cart__empty"><div>' +
      '<div class="mc-cart__empty-icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg></div>' +
      '<strong>' + esc(tr('emptyTitle', 'Your cart is empty')) + '</strong>' +
      '<p>' + esc(tr('emptyText', 'Your daily wellness routine starts here.')) + '</p>' +
      '<a href="' + esc(config.productUrl || rootUrl) + '">' + esc(tr('shop', 'Shop Quillmore')) + '</a>' +
      '</div></div>';
  }

  function render(cart) {
    updateBadges(cart);

    if (!cart.items || !cart.items.length) {
      body.innerHTML = emptyMarkup();
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (item, index) {
      return itemMarkup(item, index, cart.currency);
    }).join('');

    var finalTotal = Number(cart.total_price || 0);
    var originalTotal = cart.items.reduce(function (sum, item) {
      var compareAtUnit = Number((config.variantCompareAt || {})[String(item.variant_id)] || 0);
      var compareAtLine = compareAtUnit * Number(item.quantity || 1);
      return sum + Math.max(Number(item.original_line_price || 0), compareAtLine, Number(item.final_line_price || 0));
    }, 0);
    var totalSaved = Math.max(Number(cart.total_discount || 0), originalTotal - finalTotal, 0);

    subtotal.textContent = money(finalTotal, cart.currency);
    compareTotal.hidden = totalSaved <= 0;
    compareTotal.textContent = totalSaved > 0 ? money(originalTotal, cart.currency) : '';
    total.textContent = money(finalTotal, cart.currency);
    checkoutTotal.textContent = money(finalTotal, cart.currency);
    savingRow.hidden = totalSaved <= 0;
    saving.textContent = totalSaved > 0 ? '−' + money(totalSaved, cart.currency) : '';
    footer.hidden = false;
  }

  function getCart() {
    return fetch(endpoints.cart, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error(tr('unavailable', 'Cart unavailable'));
      return response.json();
    }).then(function (cart) {
      render(cart);
      return cart;
    });
  }

  function recoverFromError(message) {
    body.innerHTML = '<div class="mc-cart__empty"><div><strong>' + esc(tr('updateError', 'We could not update your cart.')) + '</strong><p>' + esc(message || tr('tryAgain', 'Please try again.')) + '</p></div></div>';
    footer.hidden = true;
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch(endpoints.change, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line) + 1, quantity: Number(quantity) })
    }).then(function (response) {
      if (!response.ok) throw new Error(tr('unableToUpdate', 'Unable to update cart'));
      return response.json();
    }).then(function (cart) {
      render(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function (error) {
      return getCart().catch(function () { recoverFromError(error.message); });
    }).finally(function () {
      setBusy(false);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest ? event.target : null;
    if (!target) return;

    var opener = target.closest('[data-cart-open]');
    if (opener) {
      event.preventDefault();
      open();
      setBusy(true);
      getCart().catch(function (error) { recoverFromError(error.message); }).finally(function () { setBusy(false); });
      return;
    }

    var closer = target.closest('[data-mc-cart-close]');
    if (closer) {
      close();
      return;
    }

    var changer = target.closest('[data-mc-change]');
    if (changer && root.contains(changer)) {
      change(changer.dataset.mcChange, changer.dataset.qty);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden) return;
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (checkout) {
    checkout.addEventListener('click', function () { setBusy(true); });
  }

  document.addEventListener('cart:add', function (event) {
    var detail = event.detail || {};
    var items = detail.items || [];
    if (!items.length || busy) return;

    open();
    setBusy(true);

    fetch(endpoints.add, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Unable to add to cart');
        });
      }
      return response.json();
    }).then(function (data) {
      return getCart().then(function (cart) {
        if (typeof detail.onSuccess === 'function') detail.onSuccess(data, cart);
        document.dispatchEvent(new CustomEvent('cart:added', {
          detail: { source: detail.source || '', data: data, cart: cart }
        }));
      });
    }).catch(function (error) {
      recoverFromError(error.message);
      if (typeof detail.onError === 'function') detail.onError(error);
      document.dispatchEvent(new CustomEvent('cart:add-error', {
        detail: { source: detail.source || '', error: error }
      }));
    }).finally(function () {
      setBusy(false);
    });
  });

  getCart().catch(function () {
    body.innerHTML = emptyMarkup();
    footer.hidden = true;
  });
})();
